/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartDto } from './PartDto';
import {
    PartDtoFromJSON,
    PartDtoFromJSONTyped,
    PartDtoToJSON,
    PartDtoToJSONTyped,
} from './PartDto';

/**
 * 
 * @export
 * @interface EquipmentPartDto
 */
export interface EquipmentPartDto {
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartDto
     */
    equipmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartDto
     */
    partId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartDto
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartDto
     */
    locationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartDto
     */
    secondaryLocationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof EquipmentPartDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof EquipmentPartDto
     */
    externalId?: string;
    /**
     * 
     * @type {Array<PartDto>}
     * @memberof EquipmentPartDto
     */
    parts?: Array<PartDto>;
}

/**
 * Check if a given object implements the EquipmentPartDto interface.
 */
export function instanceOfEquipmentPartDto(value: object): value is EquipmentPartDto {
    return true;
}

export function EquipmentPartDtoFromJSON(json: any): EquipmentPartDto {
    return EquipmentPartDtoFromJSONTyped(json, false);
}

export function EquipmentPartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentPartDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'equipmentId': json['equipmentId'] == null ? undefined : json['equipmentId'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'position': json['position'] == null ? undefined : json['position'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'secondaryLocationId': json['secondaryLocationId'] == null ? undefined : json['secondaryLocationId'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(PartDtoFromJSON)),
    };
}

export function EquipmentPartDtoToJSON(json: any): EquipmentPartDto {
    return EquipmentPartDtoToJSONTyped(json, false);
}

export function EquipmentPartDtoToJSONTyped(value?: EquipmentPartDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'equipmentId': value['equipmentId'],
        'partId': value['partId'],
        'position': value['position'],
        'locationId': value['locationId'],
        'secondaryLocationId': value['secondaryLocationId'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
        'externalId': value['externalId'],
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(PartDtoToJSON)),
    };
}

